import { renderToStaticMarkup } from 'react-dom/server'
import { type ResourceModel, type TemplateColumnConfig } from '@bryntum/schedulerpro'
import { selectUserConfiguration } from '@/features/domain/user'
import { store } from '@/store'
import { intl } from '@/intl'

import { OrdersCell } from '../../../components/cells/OrdersCell'
import { ordersSorter } from '../sorters/ordersSorter'

export function createOrdersColumn(
  width: string | number,
  hidden: boolean,
): Partial<TemplateColumnConfig> {
  return {
    text: intl.translate({ id: 'rm.scheduler.column.orders' }),
    type: 'template',
    field: 'orders',
    width,
    editor: false,
    hidden,
    region: 'cols',

    template: ({ record, field, value }) => {
      const state = store.getState()
      const { language } = selectUserConfiguration(state)

      return renderToStaticMarkup(
        <OrdersCell
          record={record as ResourceModel}
          field={field}
          value={value}
          language={language}
        />,
      )
    },

    sortable: ordersSorter,
    resizable: true,
    groupable: false,
  }
}
